<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"dbmsg1"' [size]=79 [line]=1 [column]=1 [(ngModel)]='dbmsg1'></dynamic-field></div>
</div>
</div>
